/**
 * What the learner sees when a unit will not open.
 *
 * A 402 is a plan boundary, not a fault. It used to be an inline banner with no button that stayed
 * on screen after switching course (owner DEV retest 2026-09-24: "It should show proper popup with
 * button to take me to subscription page"). Sol (~/.claude/sol-runs/quiklearn-guardrails/
 * owner-retest2.verdict.md, Q3 A): reuse the app-wide upgrade popup; no persistent banner. Since
 * owner 2026-09-29 that is the full-screen plans, headed "This unit requires a paid plan".
 */
import {PROFILE_INCOMPLETE_LINE} from '../../../../utils/billing/billingModel';

export const unitRefusal = error => {
  const code = String(error?.code || '');
  // The full-screen plans say what happened in the two approved patterns (owner 2026-09-29).
  if (code === 'QUOTA_EXHAUSTED') {
    return {paywall: {kind: 'quota', meter: error?.details?.meter || null, resetAt: error?.details?.resetAt || null}};
  }
  if (code === 'CONTENT_NOT_IN_PLAN' || Number(error?.status) === 402) {
    return {paywall: {kind: 'locked', subject: 'This unit', grade: error?.details?.grade ?? null}};
  }
  // A Free learner without a grade (owner 2026-10-02; Sol free-grade-units Q3 B): not a paywall - their free units
  // are Unit 1 of every course in the grade they choose, which the portal asks for.
  if (code === 'PROFILE_INCOMPLETE') {
    return {notice: PROFILE_INCOMPLETE_LINE};
  }
  return {notice: 'We could not open that lesson. Please try again.'};
};
